import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-64540747"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "tools-container" };
import ScreenFull from '@/layout/components/toolsbar/components/ScreenFull.vue';
import UserInfo from '@/layout/components/toolsbar/components/UserInfo.vue';
import OrganizationInfo from '@/layout/components/toolsbar/components/OrganizationInfo.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolsBar',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(OrganizationInfo)
                ]),
                _createElementVNode("div", null, [
                    _createVNode(ScreenFull),
                    _createVNode(UserInfo)
                ])
            ]));
        };
    }
});
